module.exports = __webpack_public_path__ + "img/UTSCOF.af664d17.png";